import { CustomerEligibilityV2Type, EntitledCatalogueEntityType, PurchaseConditionType } from 'src/lib/types/discountsV2'

export enum QuickAddOnLevel {
  ITEM = 'ITEM',
  ORDER = 'ORDER'
}

export enum QuickAddOnPriceType {
  FREE = 'FREE',
  MRP = 'DEFAULT',
  CUSTOM = 'CUSTOM'
}

export enum QuickAddOnApplyToType {
  ALL_CART_ITEMS = 'ALL_CART_ITEMS',
  SPECIFIC_PRODUCTS = 'SPECIFIC_PRODUCTS',
  SPECIFIC_COLLECTIONS = 'SPECIFIC_COLLECTIONS'
}

export enum QuickAddOnDefaultSelection {
  SELECTED = 'SELECTED',
  NOT_SELECTED = 'NOT_SELECTED'
}

export enum QuickAddOnUiAsset {
  CART = 'CART',
  CHECKOUT = 'CHECKOUT',
  DEFAULT = 'DEFAULT'
}

/** Backend-assigned semantics for an add-on that constrain which level it may run at (e.g. a cart note only makes sense order-wide) */
export enum QuickAddOnAddonType {
  CART_NOTE = 'CART_NOTE'
}

export enum QuickAddOnAddonLevel {
  ITEM = 'ITEM',
  CART = 'CART'
}

export const QuickAddOnFieldPaths = {
  NAME: 'name',
  LEVEL: 'level',
  ADD_ON_PRODUCT: 'addOn.product',
  ADD_ON_DISCOUNT_VALUE: 'addOn.discountValue',
  APPLY_TO_CATALOGUE: 'applyTo.catalogue',
  PURCHASE_CONDITION_VALUE: 'purchaseCondition.minValue',
  PURCHASE_CONDITION_MAX_VALUE: 'purchaseCondition.maxValue',
  CUSTOMER_ELIGIBILITY_MIN_ORDERS: 'customerEligibility.prerequisiteUserOrderCohort.lifetimeMinOrderCount',
  CUSTOMER_ELIGIBILITY_MAX_ORDERS: 'customerEligibility.prerequisiteUserOrderCohort.lifetimeMaxOrderCount',
  CUSTOMER_ELIGIBILITY_SEGMENT_IDS: 'customerEligibility.segmentIds',
  CUSTOMER_ELIGIBILITY_UTM_DATA: 'customerEligibility.utmParams',
  START_DATE: 'availability.startDate',
  END_DATE: 'availability.endDate'
} as const

export const QUICK_ADD_ON_SUMMARY_PLACEHOLDER_CLASS = 'text-[color:var(--Text-placeholder,#9F9FA9)]'
export const QUICK_ADD_ON_SUMMARY_FILLED_CLASS = 'text-[color:var(--Text-subtext-darker,#52525C)]'
export const QUICK_ADD_ON_SURFACE_FILL_CLASS = 'bg-[var(--Surface-Fill-active-fill,rgba(9,9,11,0.06))]'
export const QUICK_ADD_ON_SURFACE_BORDER_CLASS = 'border-[var(--Surface-Fill-active-fill,rgba(9,9,11,0.06))]'
export const QUICK_ADD_ON_FOOTER_SHADOW_CLASS =
  'shadow-[0_-31px_76px_0_rgba(0,0,0,0.05),0_-7.413px_16.976px_0_rgba(0,0,0,0.03),0_-2.585px_5.054px_0_rgba(0,0,0,0.02)]'

export const QUICK_ADD_ON_DEFAULT_DESCRIPTION =
  '<p>Add <strong>{{product_title}}</strong> for <strong>{{price}}</strong></p>'

export { CustomerEligibilityV2Type, EntitledCatalogueEntityType, PurchaseConditionType }

// All quick-add-on interfaces and type aliases (form state, backend payload shapes) live in
// quickAddOnV2Types.d.ts - re-exported here so existing imports from this module keep working.
export type {
  QuickAddOnEntitlement,
  QuickAddOnApplyTo,
  QuickAddOnPurchaseCondition,
  QuickAddOnAvailability,
  QuickAddOnFormV2StateType,
  QuickAddOnCartConditionPayload,
  QuickAddOnCustomerEligibilityPayload,
  QuickAddOnTargetingScope,
  QuickAddOnTargetingEntry,
  QuickAddOnRuleConfigPayload,
  QuickAddOnRuleMetadataPayload,
  QuickAddOnRuleCreatePayload,
  QuickAddOnListSort,
  QuickAddOnListItemPayload,
  QuickAddOnDetailPayload,
  QuickAddOnTableRow,
  QuickAddOnPriorityUpdateItem,
  QuickAddOnCheckAssociationPayload,
  QuickAddOnAssociationItem
} from './quickAddOnV2Types'
